import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import LogMasuk from '../components/LogMasuk';
import Auth from '../components/Auth';
import Loading from '../components/Loading';
import NavBar2 from '../components/NavBar2';
import EnableGift from '../components/EnableGift';
import AddressForm from '../components/AddressForm';
import AddressDisplay from '../components/AddressDisplay';
import EditAddressForm from '../components/EditAddressForm';
import NavBar from '../components/NavBar';

function Hadiah() {
  const [login, setLogin] = useState(true);
  const [loading, setLoading] = useState(true);
  const [ownerEmail, setOwnerEmail] = useState('');
  const [addressData, setAddressData] = useState(null);
  const [addressLoading, setAddressLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/clients/${id}`)
      .then(response => {
        const salamkaut_activation = response.data.salamkaut_activation;
        if(salamkaut_activation){
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch(error => {
          console.error('Error fetching data:', error);
      });
  }, [id]);

  useEffect(() => {
    setAddressLoading(true);
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/addresses/${id}`)
      .then(response => {
        if (response.data.success) {
          setAddressData(response.data.data);
          console.log("Address", response.data.data)
        }
        setAddressLoading(false);
      })
      .catch(error => {
        console.error('Error fetching address:', error);
        setAddressLoading(false);
      });
  }, [id]);

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
  };

  const handleUpdateSuccess = (updatedData) => {
    setAddressData(updatedData);
    setIsEditing(false);
  };

  const handleDelete = async () => {
    if (window.confirm('Are you sure you want to delete this address?')) {
      try {
        const response = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/addresses/${addressData.id}`);
        if (response.data.success) {
          setAddressData(null);
        }
      } catch (error) {
        console.error('Error deleting address:', error);
        alert('Failed to delete address. Please try again.');
      }
    }
  };
  
  const toWishlist = `/wishlist/${id}`

  return (
    <div>
      <Helmet>
        <title>Hadiah | PanggilanMajlis.com</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Auth id={id} setLogin={setLogin} setOwnerEmail={setOwnerEmail} />
      {login ? 
        (
          <div>
            <>
              {loading && (
                <Loading />
              )}
              <NavBar />
              <div className="md:p-24 flex items-center justify-center">
                <div className="bg-white px-8 py-12 rounded-md md:shadow-lg max-w-lg w-full">
                  <EnableGift />
                  <a href={toWishlist} className='btn-primary block w-full text-center my-4' >Add Wishlist</a>
                  {addressLoading ? (
                    <div className="mt-6 flex justify-center">
                      <Loading />
                    </div>
                  ) : addressData ? (
                    isEditing ? (
                      <EditAddressForm 
                        data={addressData}
                        onCancel={handleCancelEdit}
                        onSuccess={handleUpdateSuccess}
                      />
                    ) : (
                      <AddressDisplay 
                        data={addressData}
                        onEdit={handleEdit}
                        onDelete={handleDelete}
                      />
                    )
                  ) : (
                    <AddressForm />
                  )}
                </div>
              </div>
            </>
          </div>
        ) : ( 
          <div>
            <LogMasuk ownerEmail={ownerEmail} setLogin={setLogin} />
          </div>
        )
      }
    </div>
  );
}

export default Hadiah;
